import styled from 'styled-components';

export const MainImageContainer = styled.div`
  background: rgb(27, 40, 62);
  background-image: linear-gradient(180deg, rgba(27, 40, 62, 1) 45%, rgba(20, 26, 31, 1) 100%);
  display: flex;
  justify-content: center;
  height: 200px;
`;
